import { render, staticRenderFns } from "./TwitchMetrics.vue?vue&type=template&id=0d2cce38&"
import script from "./TwitchMetrics.vue?vue&type=script&lang=js&"
export * from "./TwitchMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports